export default "__VITE_ASSET__CGueFpAZ__"